import { type Card } from "./Card.js";
import { type Timestampable } from "./Timestampable.js";

export type Tutorial = {
    id: ID;
    name: string; // ROLE_ADMIN only
    description?: string; // ROLE_ADMIN only
    status: TutorialStatus; // ROLE_ADMIN only
    archivedAt?: Date;
    cards: Card[]; // ICard IDs
    urls?: string[];
} & Partial<Timestampable>;

export enum TutorialStatus {
    DRAFT = "draft",
    ACTIVE = "live",
    ARCHIVED = "archived",
}
